import type { IconSvgObject } from './types';

const FullSignalIcon: IconSvgObject = [
  ["path", { d: "M18.5 5H17V19H18.5M18.5 5H20V19H18.5M18.5 5V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 8H10.5V19H12M12 8H13.5V19H12M12 8V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5.5 12H4V19H5.5M5.5 12H7V19H5.5M5.5 12V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FullSignalIcon;
